import { render, staticRenderFns } from "./MidHead.vue?vue&type=template&id=c2636b24&scoped=true"
import script from "./MidHead.vue?vue&type=script&lang=js"
export * from "./MidHead.vue?vue&type=script&lang=js"
import style0 from "./MidHead.vue?vue&type=style&index=0&id=c2636b24&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2636b24",
  null
  
)

export default component.exports